((Drupal) => {
  function debounce(func, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }

  Drupal.behaviors.navlinksOverflow = {
    attach(context) {
      once("navlinks_overflow", ".theme-hbn .anchor-links", context).forEach(
        (navLinksContainer) => {
          const checkOverflow = () => {
            if (
              navLinksContainer.offsetHeight > 70 &&
              navLinksContainer.offsetWidth < 800
            ) {
              navLinksContainer.classList.add("stack");
            } else {
              navLinksContainer.classList.remove("stack");
            }
          };
          checkOverflow();
          const debouncedCheckOverflow = debounce(checkOverflow, 500);
          window.addEventListener("resize", debouncedCheckOverflow);
        }
      );
    },
  };
})(Drupal);
